/* eslint-disable indent */
/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useState } from "react";
import styled from "styled-components";

import { usePaletteService, useSchema } from "../../core/context";
import { SchemaElement } from "../../core/model";
import { SchemaTreeView } from "./SchemaTree";
import { UIElementsTree } from "./UIElementsTree";

const PalletPanel = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export interface PaletteTab {
	name: string;
	Component: React.ReactElement;
}

export interface PalettePanelProps {
	paletteTabs?: PaletteTab[];
	sortingUISchema: "name" | "type";
	setSortingUISchema: (sorting: "name" | "type") => void;
	hidePalettePanel: boolean;
	setHidePalettePanel: (hidePalettePanel: boolean) => void;
}

export const defaultPalettePanelTabs: PaletteTab[] = [
	//{ name: "UI Schema", Component: <UISchemaPanel /> },
];

export const PalettePanel: React.FC<PalettePanelProps> = ({
	paletteTabs,
	sortingUISchema,
	setSortingUISchema,
	hidePalettePanel,
	setHidePalettePanel,
}) => {
	const [selectedTab, setSelectedTab] = useState(0);
	const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
		setSelectedTab(newValue);
	};
	const schema: SchemaElement | undefined = useSchema();
	const paletteService = usePaletteService();

	return (
		<PalletPanel>
			<UIElementsTree
				elements={paletteService.getPaletteElements()}
				hidePalettePanel={hidePalettePanel}
				setHidePalettePanel={setHidePalettePanel}
			/>
			<SchemaTreeView
				schema={schema}
				hidePalettePanel={hidePalettePanel}
				sortingUISchema={sortingUISchema}
				setSortingUISchema={setSortingUISchema}
			/>
		</PalletPanel>
	);
};
